import global from "@/locales/ro-RO/global";
import error403 from "@/locales/ro-RO/errors/403";
import error404 from "@/locales/ro-RO/errors/404";
import error500 from "@/locales/ro-RO/errors/500";
import error503 from "@/locales/ro-RO/errors/503";
import error504 from "@/locales/ro-RO/errors/504";
import maintenance from "@/locales/ro-RO/auth/maintenance";
import toast from "@/locales/ro-RO/toast/toast";
import login from "@/locales/ro-RO/auth/login";
import onboarding from "@/locales/ro-RO/auth/onboarding";
import loginPageSteps from "@/locales/ro-RO/loginPageSteps";
import dashboard from "@/locales/ro-RO/dashboard/dashboard";
import account from "@/locales/ro-RO/account/account";
import mailbox from "@/locales/ro-RO/account/mailbox";
import bankstatement from "@/locales/ro-RO/account/bankstatement";
import myApps from "@/locales/ro-RO/my-apps/myApps";
import about from "@/locales/ro-RO/about/about";
import contactService from "@/locales/ro-RO/about/contactService";
import salesPromotions from "@/locales/ro-RO/sales/promotions";
import brochures from "@/locales/ro-RO/sales/brochures";
import shop from "@/locales/ro-RO/shop/data";
import priceList from "@/locales/ro-RO/shop/priceList";
import staff from "@/locales/ro-RO/dashboard/staff";
import promotions from "@/locales/ro-RO/promotions";
import points from "@/locales/ro-RO/points";
import trainings from "@/locales/ro-RO/trainings/trainings";
import vouchers from "@/locales/ro-RO/vouchers/vouchers";
import media from "@/locales/ro-RO/media/index";
import product from "@/locales/ro-RO/product/index";
import message from "@/locales/ro-RO/message/index";
import commitmentLetter from "@/locales/ro-RO/account/commitmentLetter";
import multiplicator from "@/locales/ro-RO/multiplicator";
import widgets from "@/locales/ro-RO/widgets/widgets";
import consents from "@/locales/ro-RO/consents/consents";
import investment from "@/locales/ro-RO/investment/data";
import kickback from "@/locales/ro-RO/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Imagini produse",
    BDriveLinkText: "Link către portalul IMAGINI PRODUSE",
  },
}

export default {
  locale: "ro-RO",
  messages,
};
